/*
 * The unsubscribe link in campaign emails (/my/unsubscribe?c=). Opening it changes nothing, since mail scanners open
 * links; the client presses Unsubscribe. Texts and invoices keep coming.
 */
import { useEffect, useState } from "react";
import { api } from "../api/client";
import { Banner, Button, Skeleton } from "../components/parts";
import { errText } from "../components/work";

interface Answer {
  business: string;
  email: string;
  done: boolean;
}

export function Unsubscribe() {
  const link = new URLSearchParams(window.location.search).get("c") ?? "";
  const [a, setA] = useState<Answer | null>(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api<Answer>("POST", "public/my/unsubscribe", { c: link, confirm: false }).then(setA, (e: unknown) => setErr(errText(e)));
  }, [link]);
  const go = () => {
    setBusy(true);
    api<Answer>("POST", "public/my/unsubscribe", { c: link, confirm: true }).then(
      (x) => {
        setA(x);
        setBusy(false);
      },
      (e: unknown) => {
        setErr(errText(e));
        setBusy(false);
      },
    );
  };
  return (
    <main className="unsub">
      <div className="card">
        <div className="card-body stack">
          {err ? (
            <Banner type="error">{err}</Banner>
          ) : !a ? (
            <Skeleton rows={2} />
          ) : a.done ? (
            <>
              <h1>You're unsubscribed</h1>
              <p>
                {a.business} won't send offers to {a.email} anymore. You still get emails about your visits and invoices.
              </p>
            </>
          ) : (
            <>
              <h1>Stop offers from {a.business}?</h1>
              <p>We'll stop sending offers to {a.email}. You still get emails about your visits and invoices.</p>
              <div>
                <Button loading={busy} onClick={go}>
                  Unsubscribe
                </Button>
              </div>
            </>
          )}
        </div>
      </div>
    </main>
  );
}
